import { createAction } from 'redux-actions';

export const openQuotesDrawerAction = createAction('DRAWERS/OPEN_QUOTES_DRAWER');
export const setQuotesDrawerParamsAction = createAction('DRAWERS/SET_QUOTES_DRAWER_PARAMS');
